module.exports = __webpack_public_path__ + "40cd18997f69f750a0f223c581dec2de.svg";